import React from 'react'
import {Link} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../../_metronic/layout/core'
import './dashboard.css'

type TileProps = {
  to: string
  title: string
  img?: string
}

const Dashboard: React.FC = () => {
  const intl = useIntl()

  const Tile: React.FC<TileProps> = ({to, title, img = '/media/action-img.jpg'}) => {
    return (
      <Link to={to} className='tile-link d-inline-block text-decoration-none'>
        <div className='home-tile'>
          <img className='tile-img' src={img} alt='' />
          <h2 className='tile-title text-dark'>{title}</h2>
        </div>
      </Link>
    )
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <div className='row g-4'>
        <div className='col-auto'>
          <Tile to='/customer/orders' title='View My Orders' />
        </div>
        <div className='col-auto'>
          <Tile to='/customer/quick-order' title='Make Quick Order' />
        </div>
      </div>
    </>
  )
}

export default Dashboard
